import { Link } from 'react-router-dom';
import {
    CubeIcon,
    PencilSquareIcon,
    PlusIcon,
    TrashIcon,
} from "@heroicons/react/24/outline";
import { useEffect, useState } from 'react';
import AnimacionSuccessful from '../../AnimacionSuccessful/animacionSuccessful';
import ProductsModal from './Components/ProductsModal';
// import SpinnerComponent from '../../SpinnerComponent/SpinnerComponent';

import ConfirmModal from '../../ConfirmModal/ConfirmModal';

import api from "../../../utils/axios";

import ReusableTable from '../../ReusableTable/ReusableTable';



export const AllLabs = () => {
    
    const [AllLabs, setAllLabs] = useState([]);
    const [labSelected, setLabSelected] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);

        // Estados para AnimacionSuccessful
    const [errorBool, setErrorBool] = useState(false);
    const [avisomsg, setAvisomsg] = useState('');
    const [variable, setVariable] = useState(false);

    const [showProductsModal, setShowProductsModal] = useState(false);
    const [labForProductsModal, setLabForProductsModal] = useState(null);

    const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
    const [labToDelete, setLabToDelete] = useState(null);
    const [isDeletingLab, setIsDeletingLab] = useState(false);

    const [isLoading, setIsLoading] = useState(true);

    const closeProductModal = () => {
        setShowProductsModal(false);
        setLabForProductsModal(null);
    };


    const select = (name) => {
        setLabSelected(name._id);
    };

    const deselect = () => {
        setLabSelected(null);
    };


    useEffect(() => {
        async function getLabs(){
            setIsLoading(true)
            await api.get("/laboratory?view=table").then((res) => {
                    setAllLabs(res.data.laboratories || []);
                    setIsAdmin(res.data.userdata);
                });   

            setIsLoading(false);
        }

        getLabs();
    }, []);

    // Borrar un laboratorio

    const deleteLab = async (id = labSelected) => {
        await api.delete(`/laboratory/delete/${id}`);

        setAllLabs(prevLabs => prevLabs.filter(lab => lab._id !== id));
        setLabSelected(null);

        setVariable(true);
        setErrorBool(false);
        setAvisomsg("Laboratorio eliminado correctamente");
    };

    const openProductsModal = (event, lab) => {
        event.stopPropagation();
        setLabForProductsModal(lab);
        setShowProductsModal(true);
    };

    const openDeleteConfirmModal = (event, lab) => {
        event.stopPropagation();
        setLabSelected(lab._id);
        setLabToDelete(lab);
        setShowDeleteConfirmModal(true);
    };

    const closeDeleteConfirmModal = () => {
        if (isDeletingLab) return;

        setShowDeleteConfirmModal(false);
        setLabToDelete(null);
    };

    const confirmDeleteLab = async () => {
        if (!labToDelete?._id) return;

        try {
            setIsDeletingLab(true);
            await deleteLab(labToDelete._id);
            setShowDeleteConfirmModal(false);
            setLabToDelete(null);
        } catch (error) {
            setErrorBool(true);
            setAvisomsg(
                error?.response?.data?.msg || "No se pudo eliminar el laboratorio"
            );
            setVariable(true);
        } finally {
            setIsDeletingLab(false);
        }
    };



    const laboratoryColumns = [
        {
        key: "name",
        label: "Nombre",
        render: (lab) => (
            <span className="tw-font-semibold tw-text-gray-900">{lab.name}</span>
        ),
        },
        {
        key: "officeNumber",
        label: "N° Sede",
        },
        {
        key: "address",
        label: "Dirección",
        },
        {
        key: "productsCount",
        label: "Bioquímicos",
        render: (lab) => (
            <span className="tw-inline-flex tw-min-w-7 tw-items-center tw-justify-center tw-rounded-md tw-bg-gray-100 tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-text-gray-900">
            {lab.productsCount || 0}
            </span>
        ),
        },
        {
        key: "otherProductsCount",
        label: "Varios",
        render: (lab) => (
            <span className="tw-inline-flex tw-min-w-7 tw-items-center tw-justify-center tw-rounded-md tw-bg-gray-100 tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-text-gray-900">
            {lab.otherProductsCount || 0}
            </span>
        ),
        },
        {
        key: "actions",
        label: "Acciones",
        render: (lab) => (
            <div className="tw-flex tw-items-center tw-gap-3">
            <button
                type="button"
                onClick={(event) => openProductsModal(event, lab)}
                className="tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-text-gray-900 tw-transition hover:tw-bg-gray-100"
                aria-label={`Ver productos de ${lab.name}`}
            >
                <CubeIcon className="tw-h-5 tw-w-5" />
            </button>

            <Link
                to={`edit/${lab._id}`}
                onClick={(event) => event.stopPropagation()}
                className="tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-text-gray-900 tw-transition hover:tw-bg-gray-100"
                aria-label={`Editar ${lab.name}`}
            >
                <PencilSquareIcon className="tw-h-5 tw-w-5" />
            </Link>

            <button
                type="button"
                onClick={(event) => openDeleteConfirmModal(event, lab)}
                className="tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-text-red-600 tw-transition hover:tw-bg-red-50"
                aria-label={`Eliminar ${lab.name}`}
            >
                <TrashIcon className="tw-h-5 tw-w-5" />
            </button>
            </div>
        ),
        },
    ];

    return (
        <>
        <div className= "main-container">
            <div className="header--container">
                <h1 className='title--header'>Laboratorios </h1>
            </div>

            <div className="card--container">
                <div className="tw-mx-auto tw-mt-8 tw-flex tw-w-[calc(100%-24px)] tw-items-center tw-justify-between tw-gap-4">
                    <p className="tw-m-0 tw-text-sm tw-font-normal tw-text-gray-600">
                        Total:{" "}
                        <span className="tw-font-semibold tw-text-gray-900">
                            {isLoading ? "..." : AllLabs.length}
                        </span>{" "}
                        laboratorios
                    </p>

                    <Link
                        to="add"
                        className="tw-inline-flex tw-h-9 tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-bg-black tw-px-4 tw-text-sm tw-font-semibold tw-text-white tw-no-underline tw-transition hover:tw-bg-gray-800 hover:tw-text-white"
                    >
                        <PlusIcon className="tw-h-4 tw-w-4" />
                        Nuevo Laboratorio
                    </Link>
                </div>

                <div className="table-container table-responsive">
                    <ReusableTable
                        columns={laboratoryColumns}
                        data={AllLabs}
                        loading={isLoading}
                        emptyMessage="No se encontraron laboratorios"
                        onRowClick={select}
                        onHeaderClick={deselect}
                        selectedRowId={labSelected}
                    />
                </div>
            </div>
                {/* Popup */}
            {variable ? (
                <AnimacionSuccessful 
                    errorBool={errorBool} 
                    avisomsg={avisomsg}
                    refreshPage={() => setVariable(false)}
                /> 
            ) : (
            <></>
            )}
            
            </div>
            <ProductsModal 
                show={showProductsModal} 
                lab={labForProductsModal} 
                closeProductModal={closeProductModal} 
            /> 

            <ConfirmModal
                show={showDeleteConfirmModal}
                title="Eliminar laboratorio"
                message={`¿Estás seguro de que querés eliminar ${
                    labToDelete?.name ? `"${labToDelete.name}"` : "este laboratorio"
                }? Esta acción no se puede deshacer.`}
                confirmText="Eliminar"
                cancelText="Cancelar"
                variant="danger"
                isLoading={isDeletingLab}
                onConfirm={confirmDeleteLab}
                onCancel={closeDeleteConfirmModal}
                onClose={closeDeleteConfirmModal}
            />
        </>
    );
};
